import { useMemo } from 'react';
import {
  ComponentRenderer,
  Loader,
  Error,
  ScreenableType,
  type IComponentSchema,
  IScreen,
} from '..';
import { useFetchScreen, useFetchCurrentModelSummary } from '../hooks';

interface IProps {
  screen?: IScreen;
  id: string;
  modelInstanceId?: string;
}

const Screen = ({ screen: initialScreen, id, modelInstanceId }: IProps) => {
  const {
    screen: loadedScreen,
    isLoadingScreen,
    errorFetchingScreen,
  } = useFetchScreen(id, modelInstanceId ? { modelInstanceId } : {}, {
    enabled: !initialScreen,
  });

  const screen = useMemo(
    () => initialScreen || loadedScreen,
    [initialScreen, loadedScreen]
  );

  const { modelSummary, isLoadingModelSummary } = useFetchCurrentModelSummary(
    screen?.screenableId!,
    {
      enabled:
        !!screen?.screenableId &&
        screen?.screenableType === ScreenableType.Model,
    }
  );

  if (isLoadingScreen || isLoadingModelSummary) return <Loader />;

  if (errorFetchingScreen) return <Error error={errorFetchingScreen.message} />;

  return (
    <ComponentRenderer
      schema={screen!.schema! as IComponentSchema<any>}
      screenable={modelSummary}
    />
  );
};

export default Screen;
